<template>
  <div>
    <Menu />
    <section id="banner" class="my-5">
      <div class="container">
        <div class="row justify-content-center g-0">
          <div class="col-12">
            <div class="banner-section">
              <img src="/images/banners/about.png" class="w-100" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="mt-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8 text-center">
            <h1>ABOUT CHAS EVERITT LUXURY</h1>
            <p>Discover Chas Everitt Luxury, a collection of prestigious properties supported by the experience, values and international reach of the Chas Everitt International property group.</p>
          </div>
        </div>
      </div>
    </section>
    <section id="" class="mt-5 pt-5">
      <div class="container p-0 switch-bg-lgrey p-5 bord-radius">
        <div class="row justify-content-center bord-radius">
          <div class="col-md-6 pe-lg-5">
            <h2>Why Chas Everitt?</h2>
            <p class="mt-4">The Chas Everitt International property group is seen as one of South Africa’s premier estate
              agency groups. Started in 1980, the business is built on a foundation of solid family values and a desire
              not to just serve our clients well, but to become their lifelong property counsellors by delivering truly
              memorable service.</p>
          </div>
          <div class="col-md-6 ps-lg-5">
            <h2>Our Luxury Portfolio </h2>
            <p class="mt-4">This immaculate collection houses some of South Africa’s most prestigious properties. Explore
              exquisite coastal estates, majestic safari lodges, enchanting vineyard retreats, sprawling farm manors and
              more. From breathtaking landscapes to unrivalled craftmanship, this portfolio is the epitome of luxury
              living.</p>
          </div>
        </div>
      </div>
    </section>
    <section id="" class="mt-5 mb-5 pb-5">
      <div class="container p-0">
        <div class="row justify-content-center g-0">
          <div class="col-12 position-relative">
            <div class="switch-bg-blue bord-radius p-5">
              <h2 class="switch-white">Our international partnerships</h2>
              <p class="switch-white">As a member of the prestigious Leading Real Estate Companies of the World® group and
                the exclusive Luxury Portfolio
                International group, Chas Everitt gives South African sellers the advantage of having their properties
                exposed to the international
                market. While giving property buyers, tenants, landlords and sellers a competitive advantage in the
                marketplace, we can also help
                clients relocate to any town or city in South Africa, or around the world through our international
                affiliations. </p>
            </div>
          </div>
          <div class="col-lg-6 pt-4">
            <div class="portfolio-block h-100 p-4 mx-sm-5 mx-4 bord-radius">
              <img src="images/logos/luxury-portfolio-international.png" class="w-25 mb-3"
                alt="Luxury Portfolio International" />
              <h3>Luxury Portfolio International</h3>
              <p>Luxury Portfolio International is the leading network of the world’s premier luxury real estate
                brokerages and their top agents, offering unparalleled marketing and intelligence services. It is part of
                Leading Real Estate Companies of the World®. The network includes the most respected real estate brands in
                the business and features more luxury properties on its website than any other luxury network.</p>
            </div>
          </div>
          <div class="col-lg-6 pt-4">
            <div class="portfolio-block h-100 p-4 mx-sm-5 mx-4 bord-radius">
              <img src="images/logos/leading-real-estate.png" class="w-25 mb-3" alt="Leading Real Estate Companies" />
              <h3>Leading Real Estate Companies of the World®</h3>
              <p>Leading Real Estate Companies of the World® is a global network of more than 550 premier real estate
                companies with 4 600 offices and 135 000 sales associates in more than 70+ countries. LeadingRE produces
                more annual home sales than any other real estate network. While the real estate business is largely local
                in nature, the entity that connects all of these top brands is LeadingRE, whose affiliate companies sell
                US$351 billion.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>
<script>
import Menu from '@/components/home/Menu.vue'
import Footer from '@/components/home/Footer.vue'
export default {
  components: {
    Menu, Footer
  },
  data() {
    return {
      data: {

      }
    }
  },
}
</script>